import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { useForm } from "react-hook-form";
import { ProgressBar } from "react-loader-spinner";
import Cookies from "js-cookie";

import UniversalHeader from "../commonComponents/universalHeader/UniversalHeader";
import UniversalInputComponent from "../commonComponents/universalInputComponent/UniversalInputComponent";
import TableAppBoatRegRHF from "../commonComponents/tableAppBoatRegRHF/TableAppBoatRegRHF";
import AppFooterRHF from "../commonComponents/appFooterRHF/AppFooterRHF";
import ButtonsBlock from "../../GeneralComponents/buttonsBlock/ButtonsBlock";
import ResultModalWindow from "../commonComponents/ResultModalWindow/ResultModalWindow";
import ReasonRejectModalWindow from "../../GeneralComponents/reasonRejectModalWindow/ReasonRejectModalWindow";
import ModalWindowWithInputs from "../../GeneralComponents/modalWindowWithInputs/modalWindowWithInputs";
import InputsCreatorUniversal from "../../../hooks/inputCreatorUniversal";
import QRModalWindow from "../commonComponents/QRModalWindow/QRModalWindow";
import LoaderWithOverlay from "../../GeneralComponents/loaderWithOverlay/loaderWithOverlay";

import {
  headerOptions,
  interestedPersonIndividual,
  interestedEntity,
  representPerson,
  boatInfo,
  setDocOptionsDocumentsFromDictionariesInterested,
  setOblOptionsFromDictionariesInterested,
  setDocOptionsDocumentsFromDictionariesRepresent,
  setOblOptionsFromDictionariesRepresent,
  setOptionsRepresentPerson,
  setOptionsInterestedPerson,
  setGridsByMode,
  optionsForPasswordModal,
  isNeedToPaySelector,
} from "./optionsTechnicalExaminationAppRHF";

import {
  boatTo,
  filterOptionsValidityMonths,
  setDefaultOptions,
  setOptionsForInputsUsers,
} from "./TableOptions";

import {
  clearAppDataTechExam,
  getAppDataForEditTechExam,
  getBoatCardInfoForTechExam,
} from "../../../redux/TechnicalExaminationReducer/actionsTechnicalExamination";

import { fetchWithToken } from "../../../interceptors/fetchInterceptor";
import useChapterActionIdMatch from "../../../hooks/useChapterActionIdMatch";

import {
  MAIN_URL,
  PORT,
  API_ADD_STATEMENT_TECH_EXAM,
  API_REPEAT_STATEMENT_TECH_EXAM,
  PORT_FOR_INTEGRATION,
  API_GET_INFO_BY_REG_NUM,
  API_GET_INFO_BY_PERS_NUM,
  API_GET_INFO_BY_PERS_NUM_WITH_SIGN,
  API_FOR_AVEST_SIGN,
  API_PRINT_TECH_EXAM,
  API_CHECK_POSSIBILITY_SAVING_APP_TECH_EXAM,
  API_GET_BILL,
  API_GET_QR,
} from "../../../constants/constants";

import styles from "./technicalExaminationAppRHF.module.css";

export default function TechnicalExaminationAppRHF() {
  const {
    register,
    handleSubmit,
    control,
    watch,
    formState: { errors },
    setValue,
    clearErrors,
    setError,
    getValues,
    trigger,
  } = useForm({ mode: "onChange" });

  const {
    register: registerModal,
    handleSubmit: handleSubmitModal,
    control: controlModal,
    formState: { errors: errorsModal },
    setValue: setValueModal,
    getValues: getValuesModal,
  } = useForm({
    mode: "onChange",
  });

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const userId = Cookies.get("userId");

  const mode = window.location.pathname.split("/").at(-2);
  const { additionalAccess } = location.state;
  const downloadAPI = "https://gimc.by:8080/boats/file/download/attachment/";
  const personTypeByPath = window.location.pathname.includes("individual") ? 1 : 2;
  const validationKeys = ["agentDocDate", "appDate"];
  const id = window.location.pathname.split("/").at(-1);

  const dictionaryReducer = useSelector((state) => {
    const { dictionaryReducer } = state;
    return dictionaryReducer;
  });
  const TechnicalExaminationReducer = useSelector((state) => {
    const { TechnicalExaminationReducer } = state;
    return TechnicalExaminationReducer;
  });
  const sortedMenuNames = useSelector((state) => {
    const { roleControllerReducer } = state;
    return roleControllerReducer.sortedMenuNames;
  });
  const printAccess = useChapterActionIdMatch(
    sortedMenuNames?.TECH_EXAMINATION?.printApplication?.chapterActionId,
  );

  const [options, setOptions] = useState({
    header: headerOptions,
    interested: personTypeByPath === 1 ? interestedPersonIndividual : interestedEntity,
    interestedIndividual: interestedPersonIndividual,
    interestedEntity: interestedEntity,
    represent: representPerson,
    boatInfo: boatInfo,
  });
  const [newData, setNewData] = useState({
    appDate: new Date().toLocaleDateString().split(".").reverse().join("-"),
    isNeedToPaySelector: false,
  });
  const [isLoading, setIsLoading] = useState(false);

  const [file, setFile] = useState("");
  const [viewFileName, setViewFileName] = useState("");

  const [showResultModal, setShowResultModal] = useState(false);
  const [registrationResult, setRegistrationResult] = useState("");
  const [appId, setAppId] = useState(null);
  const [errorText, setErrorText] = useState("");

  const [saveButtonDisabled, setSaveButtonDisabled] = useState(false);
  const [canAddInfo, setCanAddInfo] = useState(true);
  const [showRejectModal, setShowRejectModal] = useState(false);

  const [showPasswordModal, setShowPasswordModal] = useState(false);
  const [isLoadingModal, setIsLoadingModal] = useState(false);
  const [headerText, setHeaderText] = useState("");
  const [isPrinted, setIsPrinted] = useState(false);
  const [serviceBill, setServiceBill] = useState(null);
  const [showBillContractModal, setShowBillContractModal] = useState(false);
  const [tableError, setTableError] = useState("");

  const resolveSubmit = async (data) => {
    const { surname, name, midname, phone, isNeedToPaySelector, boatTypeId, engpwrSum } = getValues();
    if (mode === "add") {
      if (!isNeedToPaySelector) {
        handleApplication(data, false);
        return;
      }
      if (await handleApplication(data, true)) {
        const addressString = `РБ, ${
          getValues("oblId") === 5
            ? "г. Минск"
            : interestedPersonIndividual.inputsOptions.oblId.options.find(
                (item) => item.value === getValues("oblId"),
              )?.label
        }${
          getValues("rayonId")
            ? ", " +
              interestedPersonIndividual.inputsOptions.rayonId.options.find(
                (item) => item.value === getValues("rayonId"),
              )?.label +
              " район"
            : ""
        }${
          getValues("gorodId")
            ? ", " +
              interestedPersonIndividual.inputsOptions.gorodId.options.find(
                (item) => item.value === getValues("gorodId"),
              )?.label
            : ""
        }${getValues("ulica") ? ", ул. " + getValues("ulica") : ""}${
          getValues("dom") ? ", д. " + getValues("dom") : ""
        }${getValues("korpus") ? ", к. " + getValues("korpus") : ""}${
          getValues("kv") ? ", кв. " + getValues("kv") : ""
        }`;

        let codeNumber;
        switch (boatTypeId) {
          case 6:
            codeNumber = "200004";
            break;
          case 5:
            codeNumber = "200008";
            break;
          default:
            if (!engpwrSum) {
              codeNumber = "200009";
            } else {
              if (Number(engpwrSum) <= 5) {
                codeNumber = "200005";
              }
              if (Number(engpwrSum) > 5 && Number(engpwrSum) <= 30) {
                codeNumber = "200006";
              }
              if (Number(engpwrSum) > 30) {
                codeNumber = "200007";
              }
            }
            break;
        }
        setIsLoadingModal(true);
        const createdBill = await fetchWithToken(MAIN_URL + PORT_FOR_INTEGRATION + API_GET_BILL, {
          method: "POST",
          headers: {
            "Content-Type": "application/json;charset=utf-8",
          },
          body: JSON.stringify({
            address: addressString,
            surname,
            name,
            midname,
            programId: null,
            phone,
            paidProcType: null,
            codeNumber: codeNumber,
          }),
        });
        if (!createdBill.ok) {
          const response = await createdBill.json();
          setIsLoadingModal(false);
          setErrorText("Зарегистрируйте заявление без выставления счёта на оплату или попробуйте позже.");
          setHeaderText(response.message);
          setShowResultModal(!showResultModal);
        } else {
          const response = await createdBill.json();
          setIsLoadingModal(false);
          if (response.id) {
            fetchWithToken(MAIN_URL + PORT_FOR_INTEGRATION + API_GET_QR, {
              method: "POST",
              headers: {
                "Content-Type": "application/json;charset=utf-8",
              },
              body: JSON.stringify({
                serviceBillId: response.serviceBillId,
              }),
            })
              .then((res) => res.blob())
              .then((blob) => {
                setServiceBill({
                  id: response.serviceBillId,
                  QRurl: URL.createObjectURL(blob),
                  onClose: () => {
                    handleApplication({ ...data, billDataId: response.id }, false);
                    setShowBillContractModal(false);
                  },
                });
                setShowBillContractModal(true);
              });
          }
        }
      }
    } else {
      handleApplication(data, false);
    }
  };

  const handleApplication = async (data, check, fileCheck) => {
    const api =
      check === "file"
        ? API_PRINT_TECH_EXAM
        : check
        ? API_CHECK_POSSIBILITY_SAVING_APP_TECH_EXAM
        : API_ADD_STATEMENT_TECH_EXAM;
    if (handleCustomDateValidation() || fileCheck) {
      switch (mode) {
        case "add":
          {
            if (TechnicalExaminationReducer.boatTo.length > newData.boatTo.length || fileCheck) {
              const formData = new FormData();
              const newStatement = {
                ...newData,
                ...data,
                boatTo: TechnicalExaminationReducer.boatTo,
              };
              formData.append("data", JSON.stringify(newStatement));
              if (file !== undefined && file !== null) {
                formData.append(`file`, file);
              }
              for (let item in newStatement) {
                if (newStatement[item] === null || newStatement[item] === undefined) {
                  delete newStatement[item];
                }
              }
              const request = await fetchWithToken(
                `${MAIN_URL}${PORT}${api}${id}${check === "file" ? "/" + personTypeByPath : ""}`,
                {
                  method: "POST",
                  body: check === "file" ? JSON.stringify(newStatement) : formData,
                },
              );
              if (request.status !== 200) {
                const response = await request.text();
                setErrorText(response);
                setShowResultModal(!showResultModal);
                setRegistrationResult("error");

                if (check && check !== "file") {
                  return false;
                }
              } else {
                if (check === "file") {
                  const formData = await request.formData();
                  const fileDocx = formData.get("docx");
                  const fileUrl = URL.createObjectURL(fileDocx);
                  const link = document.createElement("a");
                  link.href = fileUrl;
                  link.download = fileDocx.name;
                  link.click();
                  setIsPrinted(true);
                } else {
                  if (check) {
                    return true;
                  } else {
                    const response = await request.text();
                    setAppId(response);
                    setShowResultModal(!showResultModal);
                    setRegistrationResult("success");
                  }
                }
              }
            }
          }
          break;
        case "edit":
          {
            if (TechnicalExaminationReducer.boatTo.length > newData.boatTo.length) {
              if (handleCustomDateValidation()) {
                const newTo =
                  TechnicalExaminationReducer.boatTo[TechnicalExaminationReducer.boatTo.length - 1];
                const request = await fetchWithToken(MAIN_URL + PORT + API_REPEAT_STATEMENT_TECH_EXAM + id, {
                  method: "POST",
                  headers: {
                    "Content-Type": "application/json",
                  },
                  body: JSON.stringify(newTo),
                });
                if (request.status !== 200) {
                  setShowResultModal(!showResultModal);
                  setRegistrationResult("error");
                } else {
                  const response = await request.text();
                  setAppId(response);
                  setShowResultModal(!showResultModal);
                  setRegistrationResult("success");
                }
              }
            }
          }
          break;
        default:
          break;
      }
    }
  };

  const handleDownloadFile = async (e) => {
    if (e) {
      e.preventDefault();
      if (await trigger()) {
        if (await handleApplication(getValues(), true, true)) {
          handleApplication(getValues(), "file", true);
        }
      }
    }
  };

  const handleRefuseTechnicalExamination = async () => {
    const formData = new FormData();
    const newStatement = { ...newData, status: 2 };
    formData.append("data", JSON.stringify(newStatement));
    if (file !== undefined && file !== null) {
      formData.append(`file`, file);
    }
    const request = await fetchWithToken(MAIN_URL + PORT + API_ADD_STATEMENT_TECH_EXAM + id, {
      method: "POST",
      body: formData,
    });
    if (request.status !== 200) {
      setShowResultModal(!showResultModal);
      setRegistrationResult("error");
    } else {
      const response = await request.text();
      setAppId("Refuse");
      setShowResultModal(!showResultModal);
      setRegistrationResult("success");
    }
  };

  const getUserInfoById = async () => {
    const { agentPersNum } = getValues();
    const { pw } = getValuesModal();

    const setDataAfterRequest = async (data) => {
      for (const [key, val] of Object.entries(data)) {
        if (val) {
          newData[key] = val;
          setValue(key, val);
        }
      }
      if (data.agentOblId) newData.agentCountry = "РЕСПУБЛИКА БЕЛАРУСЬ";
      setNewData(structuredClone(newData, getValues()));
    };

    const setOptionsAfterRequest = async (data) => {
      if (data.agentOblId) {
        setOptions({
          ...options,
          represent: await setOptionsRepresentPerson(data, "agentOblId"),
        });
      }
      if (data.agentRayonId) {
        setOptions({
          ...options,
          represent: await setOptionsRepresentPerson(data, "agentRayonId"),
        });
      }
    };

    if (agentPersNum) {
      if (!/^[0-9]{7}[A-Z]{1}[0-9]{3}[A-Z]{2}[0-9]{1}$/.test(agentPersNum)) {
        setError("agentPersNum", {
          type: "manual",
          message: `Введите номер в формате "0000000A000AA0"`,
        });
        return;
      } else {
        clearErrors("agentPersNum");
        setIsLoadingModal(true);
        await fetchWithToken(MAIN_URL + PORT_FOR_INTEGRATION + API_GET_INFO_BY_PERS_NUM + agentPersNum, {
          headers: { "Content-Type": "application/json" },
        })
          .then(async (res) => {
            if (!res.ok) {
              throw new Error(`Ошибка сети: ${res.status}`);
            }
            return res.json();
          })
          .then(async (dataForInnerRequest) => {
            let resInner;
            let resWithData;
            try {
              resInner = await fetch(API_FOR_AVEST_SIGN, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ ...dataForInnerRequest, pw: pw }),
              });
            } catch (error) {
              resWithData = await fetchWithToken(
                MAIN_URL +
                  PORT_FOR_INTEGRATION +
                  API_GET_INFO_BY_PERS_NUM_WITH_SIGN +
                  `${userId}/${agentPersNum}?agent=2`,
                {
                  method: "POST",
                  body: JSON.stringify({
                    headers: null,
                    body: null,
                    identificationNumber: agentPersNum,
                    log: false,
                  }),
                  headers: { "Content-Type": "application/json" },
                },
              );
            }

            if (resInner) {
              if (!resInner.ok) {
                const errorText = await resInner.text();
                if (errorText === "Invalid container password") {
                  throw new Error(`Ошибка подписи! Неверный пароль.`);
                }
                resWithData = await fetchWithToken(
                  MAIN_URL +
                    PORT_FOR_INTEGRATION +
                    API_GET_INFO_BY_PERS_NUM_WITH_SIGN +
                    `${userId}/${agentPersNum}?agent=2`,
                  {
                    method: "POST",
                    body: JSON.stringify({
                      headers: null,
                      body: null,
                      identificationNumber: agentPersNum,
                      log: false,
                    }),
                    headers: { "Content-Type": "application/json" },
                  },
                );
              } else {
                const dataWithSign = await resInner.json();

                resWithData = await fetchWithToken(
                  MAIN_URL +
                    PORT_FOR_INTEGRATION +
                    API_GET_INFO_BY_PERS_NUM_WITH_SIGN +
                    `${userId}/${agentPersNum}?agent=2`,
                  {
                    method: "POST",
                    body: JSON.stringify(dataWithSign),
                    headers: { "Content-Type": "application/json" },
                  },
                );
              }
            }
            const dataWithInformation = await resWithData.json();
            if (!resWithData.ok) {
              throw new Error(dataWithInformation.message);
            } else {
              setOptionsAfterRequest(dataWithInformation);
              setDataAfterRequest(dataWithInformation);
              setShowPasswordModal(false);
            }
          })
          .catch((error) => {
            setErrorText(error.message);
            setHeaderText("Заполните поля вручную или повторите заново");
            setRegistrationResult("error");
            setShowResultModal(true);
            clearErrors("agentPersNum");
            setIsLoadingModal(false);
          });
        clearErrors("agentPersNum");
        setIsLoadingModal(false);
      }
    } else {
      setError("agentPersNum", {
        type: "manual",
        message: "Для поиска заполните поле",
      });
    }
  };

  const setOptionsFromLibs = () => {
    if (Object.values(dictionaryReducer.identificationDocuments).length > 0) {
      setDocOptionsDocumentsFromDictionariesInterested(dictionaryReducer.identificationDocuments);
      setDocOptionsDocumentsFromDictionariesRepresent(dictionaryReducer.identificationDocuments);
    }
    if (Object.values(dictionaryReducer.allOblast).length > 0) {
      setOblOptionsFromDictionariesInterested(dictionaryReducer.allOblast);
      setOblOptionsFromDictionariesRepresent(dictionaryReducer.allOblast);
    }
    if (Object.values(dictionaryReducer.usersLibrary).length > 0) {
      setOptionsForInputsUsers(dictionaryReducer.usersLibrary);
    }
  };

  const handleFile = (e) => {
    if (e) {
      if (e.target.files[0]) {
        setFile(e.target.files[0]);
      }
    }
  };

  const clearFile = (e) => {
    setFile("");
    e.preventDefault();
  };

  const handleReasonReject = (value) => {
    newData["reasonReject"] = value;
    setNewData(structuredClone(newData));
  };

  const handleCloseRejectModal = () => {
    newData["reasonReject"] = null;
    setNewData(structuredClone(newData));
    setShowRejectModal(false);
  };

  const handleOpenRejectModal = () => {
    setShowRejectModal(true);
  };

  const handleCloseApp = () => {
    setFile(null);
    dispatch(clearAppDataTechExam());
    navigate("/techexamination");
  };

  const handleCustomDateValidation = (value, key) => {
    if (mode === "add") {
      if (TechnicalExaminationReducer.boatTo.length > 0) {
        const toItem = TechnicalExaminationReducer.boatTo.find((item) => item.hasOwnProperty("innerId"));
        if (toItem) {
          if (new Date(toItem.toDate).getTime() !== new Date(getValues("appDate")).getTime()) {
            setError("appDate", {
              type: "manual",
              message: "Дата ТО и дата подачи заявление должны совпадать",
            });
            return false;
          } else {
            clearErrors("appDate");
            return true;
          }
        }
      }
    }
    if (mode === "edit") {
      if (TechnicalExaminationReducer.boatTo.length > 0) {
        const toItem = TechnicalExaminationReducer.boatTo.find((item) => item.hasOwnProperty("innerId"));
        if (toItem) {
          if (
            new Date(toItem.toDate).getTime() <
            new Date(TechnicalExaminationReducer.boatTo.at(-2).toDate).getTime()
          ) {
            setTableError("Дата повторного ТО и не может быть раньше даты признания судна негодным");
            return false;
          } else {
            setTableError("");
            return true;
          }
        }
      }
    }
  };

  useEffect(() => {
    const asyncWatch = async (value, { name, type }) => {
      if (type !== undefined) {
        if (newData[name] !== value[name]) {
          newData[name] = value[name];
          if (name === "agentOblId" || name === "agentRayonId" || name === "agentGorodId") {
            setOptions({
              ...options,
              represent: await setOptionsRepresentPerson(value, name, personTypeByPath),
            });
            if (name === "agentOblId") {
              setValue("agentRayonId", undefined);
              setValue("agentGorodId", undefined);
            }
          }
          if ((name === "oblId" || name === "rayonId" || name === "gorodId") && personTypeByPath) {
            if (name === "oblId") {
              setValue("rayonId", undefined);
              setValue("gorodId", undefined);
            }
            setOptions({
              ...options,
              interested: await setOptionsInterestedPerson(value, name, personTypeByPath),
            });
          }
        }
        if (name === "appDate") handleCustomDateValidation(name, value);
      }
    };
    const subscription = watch(asyncWatch);
    return () => subscription.unsubscribe();
  }, [watch]);

  useEffect(() => {
    setOptionsFromLibs();
  }, [dictionaryReducer]);

  useEffect(() => {
    setOptionsFromLibs();
  }, []);

  useEffect(() => {
    switch (mode) {
      case "add":
        dispatch(getBoatCardInfoForTechExam(id));
        break;
      case "edit":
        dispatch(getAppDataForEditTechExam(id));
        break;
      case "view":
        dispatch(getAppDataForEditTechExam(id));
        break;
      default:
        break;
    }
    setIsLoading(false);
  }, []);

  useEffect(() => {
    if (!!TechnicalExaminationReducer.boatTo && !!newData.boatTo) {
      if (TechnicalExaminationReducer.boatTo.length <= newData.boatTo.length) {
        setSaveButtonDisabled(true);
        setCanAddInfo(true);
      } else {
        setSaveButtonDisabled(false);
        setCanAddInfo(false);
      }
      handleCustomDateValidation();
    }
  }, [TechnicalExaminationReducer.boatTo, newData.boatTo]);

  useEffect(() => {
    async function setoptionsInterested(value, key, type) {
      setOptions({
        ...options,
        interested: await setOptionsInterestedPerson(value, key, type),
      });
    }
    async function setoptionsRepresent(value, key) {
      setOptions({
        ...options,
        represent: await setOptionsRepresentPerson(value, key),
      });
    }
    if (Object.values(TechnicalExaminationReducer.newAppTechExam).length > 0) {
      if (TechnicalExaminationReducer.newAppTechExam["oblId"] && personTypeByPath) {
        setoptionsInterested(TechnicalExaminationReducer.newAppTechExam, "oblId", personTypeByPath);
      }
      newData.stranId = "РЕСПУБЛИКА БЕЛАРУСЬ";
      newData.agentCountry = "РЕСПУБЛИКА БЕЛАРУСЬ";
      if (TechnicalExaminationReducer.newAppTechExam["rayonId"] && personTypeByPath) {
        setoptionsInterested(TechnicalExaminationReducer.newAppTechExam, "rayonId", personTypeByPath);
      }
      if (mode === "view") {
        if (TechnicalExaminationReducer.newAppTechExam["agentOblId"]) {
          setoptionsRepresent(TechnicalExaminationReducer.newAppTechExam, "agentOblId");
          newData.agentCountry = "РЕСПУБЛИКА БЕЛАРУСЬ";
        }
        if (TechnicalExaminationReducer.newAppTechExam["agentRayonId"]) {
          setoptionsRepresent(TechnicalExaminationReducer.newAppTechExam, "agentRayonId");
        }
      }
      if (mode === "add" || mode === "edit") {
        for (let item in TechnicalExaminationReducer.newAppTechExam) {
          setValue(item, TechnicalExaminationReducer.newAppTechExam[item]);
        }
      }
      if (Object.values(TechnicalExaminationReducer.newAppTechExam).length > 0) {
        filterOptionsValidityMonths(
          TechnicalExaminationReducer.newAppTechExam.boatTypeId,
          TechnicalExaminationReducer.newAppTechExam.boatYear,
          TechnicalExaminationReducer.newAppTechExam.engPower,
        );
      }

      setNewData({ ...newData, ...TechnicalExaminationReducer.newAppTechExam });
      setIsLoading(false);
    }
  }, [TechnicalExaminationReducer.newAppTechExam]);

  useEffect(() => {
    if (Object.values(TechnicalExaminationReducer.newAppTechExam).length > 0) {
      filterOptionsValidityMonths(
        TechnicalExaminationReducer.newAppTechExam.boatTypeId,
        TechnicalExaminationReducer.newAppTechExam.boatYear,
        TechnicalExaminationReducer.newAppTechExam.engPower,
      );
    }
  }, [boatTo.nameColumn[3].selectOptions.length]);

  useEffect(() => {
    setOptions({ ...options, ...setGridsByMode(mode, personTypeByPath) });
  }, [mode]);

  useEffect(() => {
    if (personTypeByPath) {
      setOptions({
        ...options,
        interested: personTypeByPath === 1 ? interestedPersonIndividual : interestedEntity,
      });
    }
  }, [personTypeByPath]);

  useEffect(() => {
    setValue("isNeedToPaySelector", newData.isNeedToPaySelector);
  }, []);

  return (
    <>
      <div className={styles["content-container"]}>
        <h1 className={styles["main-text"]}>Заявление</h1>
        <p className={styles["description-text"]}>
          {TechnicalExaminationReducer.newAppTechExam?.personType === 1
            ? "о техническом освидетельствовании маломерных судов, за исключением гребных лодок, байдарок и надувных судов грузоподъемностью менее 225 килограммов"
            : "о техническом освидетельствовании маломерного судна"}
        </p>
        {isLoading ? (
          <div className={`d-flex flex-column align-items-center `}>
            <ProgressBar
              height="80"
              width="80"
              ariaLabel="progress-bar-loading"
              wrapperStyle={{}}
              wrapperClass="progress-bar-wrapper"
              borderColor="#D2AF8E"
              barColor="#BC8653"
            />
          </div>
        ) : (
          <form onSubmit={handleSubmit(resolveSubmit)}>
            <UniversalHeader
              options={options.header}
              mode={mode}
              styles={styles}
              newData={newData}
            />
            <UniversalInputComponent
              options={options.interested}
              mode={mode}
              styles={styles}
              newData={newData}
              register={register}
              control={control}
              setValue={setValue}
              errors={errors}
              clearErrors={clearErrors}
            />
            <UniversalInputComponent
              options={options.represent}
              mode={mode === "add" ? "add" : "view"}
              styles={styles}
              register={register}
              newData={newData}
              control={control}
              setValue={setValue}
              errors={errors}
              clearErrors={clearErrors}
              handleCustomButton={() => {
                if (!/^[0-9]{7}[A-Z]{1}[0-9]{3}[A-Z]{2}[0-9]{1}$/.test(getValues("agentPersNum"))) {
                  setError("agentPersNum", {
                    type: "manual",
                    message: `Введите номер в формате "0000000A000AA0"`,
                  });
                } else {
                  setShowPasswordModal(true);
                }
              }}
            />
            <UniversalInputComponent
              options={options.boatInfo}
              mode={mode}
              styles={styles}
              newData={newData}
            />
            <TableAppBoatRegRHF
              typeTable={"boatTo"}
              tableOptions={boatTo}
              mode={mode}
              canAddInfo={canAddInfo}
              addAccess={additionalAccess?.addAccess}
              buttonText={"Добавить информацию"}
              error={tableError}
              setDefaultOptions={() => {
                filterOptionsValidityMonths(
                  TechnicalExaminationReducer.newAppTechExam.boatTypeId,
                  TechnicalExaminationReducer.newAppTechExam.boatYear,
                  TechnicalExaminationReducer.newAppTechExam.engPower,
                );
                setDefaultOptions();
              }}
            />
            {mode === "view" && newData.reasonReject && (
              <div className={styles["reject-reason-block"]}>
                {"Причина отказа: "}
                <span className={styles["danger"]}>{newData.reasonReject}</span>
              </div>
            )}
            {mode === "add" && TechnicalExaminationReducer.newAppTechExam?.personType === 1 && (
              <div className={styles["exam-type-block"]}>
                <InputsCreatorUniversal
                  option={isNeedToPaySelector}
                  styles={styles}
                  register={register}
                  newData={newData}
                  control={control}
                  setValue={setValue}
                  mode={mode}
                  errors={errors}
                  clearErrors={clearErrors}
                />
              </div>
            )}
            <AppFooterRHF
              mode={mode === "add" ? "add" : "view"}
              register={register}
              control={control}
              setValue={setValue}
              clearErrors={clearErrors}
              errors={errors}
              newData={newData}
              styles={styles}
              handleFile={handleFile}
              clearFile={clearFile}
              fileName={file?.name}
              fileDownloadApi={downloadAPI}
              viewFileName={viewFileName}
              // isFileRequired={isFileRequired}
              // isFileRequiredError={isFileRequiredError}
            />
            <ButtonsBlock
              closeBtnText={!isPrinted && "Закрыть"}
              declineBtnText={mode === "add" && additionalAccess?.decline && "Отказать"}
              handleDeclineBtn={handleOpenRejectModal}
              saveBtnText={(mode === "add" || mode === "edit") && !saveButtonDisabled && "Зарегистрировать"}
              extraBtnText={mode === "add" && printAccess && "Распечатать"}
              handleCloseBtn={() => {
                handleCloseApp();
                navigate("/techexamination");
              }}
              handleExtraBtn={handleDownloadFile}
              mobileFullScreen={
                (mode === "add" || mode === "edit") && !saveButtonDisabled && additionalAccess?.decline
              }
            />
          </form>
        )}
      </div>
      {showResultModal && (
        <ResultModalWindow
          appId={appId}
          show={showResultModal}
          setShow={setShowResultModal}
          result={registrationResult}
          handleCloseApp={handleCloseApp}
          errorText={errorText}
          headerTextExternal={headerText}
          handleCloseExternal={() => {
            setErrorText("");
            setHeaderText("");
          }}
        />
      )}
      <ModalWindowWithInputs
        showModal={showPasswordModal}
        setShowModal={setShowPasswordModal}
        textButton={"Сохранить"}
        externalStyles={styles}
        inputsOptions={optionsForPasswordModal}
        mode={"add"}
        handleSubmit={handleSubmitModal}
        register={registerModal}
        control={controlModal}
        setValue={setValueModal}
        errors={errorsModal}
        clearErrors={clearErrors}
        handle={getUserInfoById}
        isLoadingModal={isLoadingModal}
      />
      {showBillContractModal && (
        <QRModalWindow
          show={showBillContractModal}
          setShow={setShowBillContractModal}
          billId={serviceBill.id}
          billQRurl={serviceBill.QRurl}
          onClose={serviceBill.onClose}
        />
      )}
      {showRejectModal && (
        <ReasonRejectModalWindow
          show={showRejectModal}
          setShow={setShowRejectModal}
          headerText={"Введите причину отказа:"}
          handleReasonReject={handleReasonReject}
          handleCloseRejectModal={handleCloseRejectModal}
          handleRefuse={handleRefuseTechnicalExamination}
          textareaPlaceholder={"Введите причину отказа"}
        />
      )}
      <LoaderWithOverlay isLoading={isLoadingModal} />
    </>
  );
}
